module.exports = __webpack_public_path__ + "static/img/pdf.8048d9ee.png";